import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=1668e044&scoped=true"
import script from "./offer.vue?vue&type=script&lang=js"
export * from "./offer.vue?vue&type=script&lang=js"
import style0 from "./offer.vue?vue&type=style&index=0&id=1668e044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668e044",
  null
  
)

export default component.exports